import Box from "./Box";
import Checkbox from "./Checkbox";
import FormInput from "./FormInput";
import LozengeButton from "./LozengeButton";
import PropTypes from "prop-types";
import React from "react";
import { useAppContext } from "./AppContext";

function CourierServiceFinder({
  handleChange,
  postcodeValue,
  postcodeError,
  labelTypeValue,
  labelTypeError,
  courierServiceValue,
  courierServiceError,
}) {
  const {
    dropOffServices,
    getDropOffServices,
    dropOffServicesLoading,
    dropOffServicesCalled,
    handleDropOffServiceSelect,
  } = useAppContext();
  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection={["column", "row", null, null]}
      >
        <FormInput
          name="postcode"
          error={courierServiceError || postcodeError || labelTypeError}
          value={postcodeValue}
          placeholder="Postcode"
          handleChange={handleChange}
          type="text"
          label="Enter your postcode to find and select your drop off partner"
          autoComplete="postal-code"
        />
        <Box ml={[0, 20, null, null]} mt={[20, 0, null, null]}>
          <LozengeButton
            onClick={getDropOffServices}
            height="62px"
            disabled={
              postcodeValue === "" ||
              (dropOffServicesCalled && dropOffServicesLoading)
            }
          >
            {dropOffServicesCalled && dropOffServicesLoading
              ? "Loading"
              : "Find"}
          </LozengeButton>
        </Box>
      </Box>
      {dropOffServices.length > 0 && (
        <Box pt={30}>
          {dropOffServices.map((dropOffService, index) => {
            return (
              <Box pt={"10px"} key={index}>
                <Checkbox
                  name={dropOffService.labelType}
                  checked={
                    dropOffService.courierServiceId === courierServiceValue &&
                    dropOffService.labelType === labelTypeValue
                  }
                  onClick={() => {
                    handleDropOffServiceSelect(dropOffService);
                  }}
                >
                  {`${
                    dropOffService.courierServiceName
                  } ${dropOffService.labelType.replace(/_/g, " ")} (${
                    dropOffService.distance
                  } away)`}
                </Checkbox>
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
}

CourierServiceFinder.propTypes = {
  handleChange: PropTypes.func.isRequired,
  postcodeValue: PropTypes.string,
  postcodeError: PropTypes.string,
  courierServiceValue: PropTypes.string,
  courierServiceError: PropTypes.string,
  labelTypeValue: PropTypes.string,
  labelTypeError: PropTypes.string,
};

export default CourierServiceFinder;
